"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostReportMessage = exports.isHostInsightsMessage = exports.isTrackMessage = exports.isRuntimeInfoMessage = exports.isOxygenIDMessage = exports.isInitMessage = exports.isAdpAnalyticsMessage = exports.WorkerToIpmEventType = exports.IpmToWorkerEventType = void 0;
var IpmToWorkerEventType;
(function (IpmToWorkerEventType) {
    IpmToWorkerEventType["INIT"] = "init";
    IpmToWorkerEventType["USER"] = "oxygenID";
    IpmToWorkerEventType["RUNTIME"] = "runtimeInfo";
    IpmToWorkerEventType["TRACK"] = "track";
})(IpmToWorkerEventType = exports.IpmToWorkerEventType || (exports.IpmToWorkerEventType = {}));
var WorkerToIpmEventType;
(function (WorkerToIpmEventType) {
    WorkerToIpmEventType["MESSAGE_GENERATED"] = "messageGenerated";
    WorkerToIpmEventType["REPORT"] = "report";
})(WorkerToIpmEventType = exports.WorkerToIpmEventType || (exports.WorkerToIpmEventType = {}));
function isAdpAnalyticsMessage(ev) {
    const { data } = ev;
    return "type" in data && "payload" in data;
}
exports.isAdpAnalyticsMessage = isAdpAnalyticsMessage;
function isInitMessage(ev) {
    return ev.data.type === IpmToWorkerEventType.INIT;
}
exports.isInitMessage = isInitMessage;
function isOxygenIDMessage(ev) {
    return ev.data.type === IpmToWorkerEventType.USER;
}
exports.isOxygenIDMessage = isOxygenIDMessage;
function isRuntimeInfoMessage(ev) {
    return ev.data.type === IpmToWorkerEventType.RUNTIME;
}
exports.isRuntimeInfoMessage = isRuntimeInfoMessage;
function isTrackMessage(ev) {
    return ev.data.type === IpmToWorkerEventType.TRACK;
}
exports.isTrackMessage = isTrackMessage;
function isHostInsightsMessage(ev) {
    return ev.data.type === WorkerToIpmEventType.MESSAGE_GENERATED;
}
exports.isHostInsightsMessage = isHostInsightsMessage;
function isHostReportMessage(ev) {
    return ev.data.type === WorkerToIpmEventType.REPORT;
}
exports.isHostReportMessage = isHostReportMessage;
